import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthStatusController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthStatusController.php
* @route '/api/company/{company}/square-up/auth-status'
*/
const GetSquareUpAuthStatusController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSquareUpAuthStatusController.url(args, options),
    method: 'get',
})

GetSquareUpAuthStatusController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/square-up/auth-status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthStatusController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthStatusController.php
* @route '/api/company/{company}/square-up/auth-status'
*/
GetSquareUpAuthStatusController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetSquareUpAuthStatusController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthStatusController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthStatusController.php
* @route '/api/company/{company}/square-up/auth-status'
*/
GetSquareUpAuthStatusController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSquareUpAuthStatusController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthStatusController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthStatusController.php
* @route '/api/company/{company}/square-up/auth-status'
*/
GetSquareUpAuthStatusController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSquareUpAuthStatusController.url(args, options),
    method: 'head',
})

export default GetSquareUpAuthStatusController